import React, { Component } from 'react';
import {unlockCollateral} from '../../../../actions/orderbook/set';
import Modal from '../../../helper/modal';
import M from 'materialize-css/dist/js/materialize.min.js'
import $ from 'jquery';
import { connect } from 'react-redux';
import {colors} from '../../../../config'
import TableHeader from '../../../helper/tableHeader';
import {take} from 'ramda';
import InfiniteScroll from 'react-infinite-scroll-component';

const {green} = colors;

class Orders extends Component {
  constructor(){
    super()
    this.state = {unlocking:{},txData:[],canceling:{},hasMore:false,nextIndex:1,orders:[]}
  }
  componentDidUpdate(prevProps){
    if(prevProps.orders.length === 0 && this.props.orders.length > 0){
      this.setState({orders:take(20,this.props.orders),hasMore:true})
    }
    else if(this.props.orders.length != prevProps.orders.length){
      this.setState({hasMore:true,orders:take(this.state.nextIndex*20,this.props.orders)})
    }
  }
  componentDidMount(){
    this.setState({orders:take(20,this.props.orders),hasMore:true})
  }
  fetchMoreData(){
    let { nextIndex, orders} = this.state;
    nextIndex++;
    this.setState({orders:take(20*nextIndex,this.props.orders),nextIndex})
    if(20*nextIndex >= this.props.orders.length){
      this.setState({hasMore:false,nextIndex})
    }
    return;
  }
  renderUnlock(){
    let component = <div style={{overflowY:'scroll',maxHeight:'500px'}}>
      {this.state.txData.map(({amount},i)=>{
        return (
          <>
          <div className='row mbd'>
            <div className="row mi">
              <h6 className='leftInfo'><b>Collateral</b></h6>
              <h6 className="rightInfo">{amount} OVERLINE</h6>
            </div>
          </div>
          {i != this.state.txData.length - 1 && <br/>}
          </>
        )
      })}
    </div>

    return (
      <Modal id='modalUnlock2' component={component} style={{maxWidth:'500px'}} chain='BSEC' noClose={true} classes='modal modalOrders black-text' title='Unlock Confirmation' decryption={true} buttonText={"Confirm"} passwordId='unlockpass2' buttonAction={this.submitOperationUnlock.bind(this)} />
    )
  }
  submitOperationUnlock(){
    let password = $("#unlockpass2").val();
    this.props.unlockCollateral({password,txData:this.state.txData},(err,tx)=>{
      if(!err) {
        var instance = M.Modal.getInstance(document.querySelectorAll('#modalUnlock2')[0]);
        if(instance) instance.close();
        $("#unlockpass2")[0].value = '';
        M.toast({html: 'Transaction Submitted!',classes: "green",displayLength:3000});

        let unlocking = this.state.unlocking;
        this.state.txData.map(({txHash,txOutputIndex})=>{
          unlocking[`${txHash}.${txOutputIndex}.unlock`] = true;
        })
        this.setState({unlocking})
      }
      else {
        M.toast({html: err,classes:"red",displayLength:3000});
      }
    })
  }
  handleAllUnlock(){
    let txData = this.props.orders.filter(({unlocking,txHash,txOutputIndex,unlock})=> {
      if(unlocking || this.state.unlocking[`${txHash}.${txOutputIndex}.unlock`]) return false;
      if(unlock.makerLeft > 0 || unlock.takerLeft > 0 || unlock.bcLeft > 0) return false;
      else return true;
    }).map(({address,collateralizedNrg,txHash,txOutputIndex}) => {
      return {amount:collateralizedNrg,txHash,txOutputIndex,address}
    })
    if(txData.length === 0) {
      M.toast({html: 'No Orders to Unlock',classes: "red",displayLength:3000});
    }
    else {
      this.setState({txData});
      var instance = M.Modal.getInstance(document.querySelectorAll('#modalUnlock2')[0]);
      if(instance) instance.open();
      setTimeout(()=>{
        if($("#unlockpass2")) $("#unlockpass2").focus()
      },100)
    }
  }
  handleFormSubmitUnlock({address,txHash,txOutputIndex,amount}) {
    let txData = [{amount,txHash,txOutputIndex,address}]
    this.setState({txData});
    var instance = M.Modal.getInstance(document.querySelectorAll('#modalUnlock2')[0]);
    if(instance) instance.open();
    setTimeout(()=>{
      if($("#unlockpass2")) $("#unlockpass2").focus()
    },100)
  }
  renderItemUnlock(offers){
    var items = offers.map(({address,unlock,receivesUnit,sendsUnit,shiftMaker,unlocking, sendsFromChain,receivesToChain,collateralizedNrg,txHash,txOutputIndex},i) => {
      let unlockClick = this.handleFormSubmitUnlock.bind(this,{amount:collateralizedNrg,address,txHash,txOutputIndex})

      let you = `Unlock ${unlock.unlockText}`;
      if(!(unlock.bcLeft > 0 || unlock.makerLeft > 0 || unlock.takerLeft > 0)) you = <button onClick={unlockClick} className="btn clickables" >Unlock</button>;
      if(unlocking) you = <a style={{color:'grey'}}>{`Unlocking`} </a>
      if(this.state.unlocking[`${txHash}.${txOutputIndex}.unlock`]) you = <a style={{color:'grey'}}>{`Unlocking`} </a>

      return (
        <tr onMouseOver={()=>{console.log({txHash, txOutputIndex})}}>
          <td >{sendsUnit} <span > {sendsFromChain.toUpperCase().replace('NRG','OVERLINE')}</span></td>
          <td>{receivesUnit} <span > {receivesToChain.toUpperCase().replace('NRG','OVERLINE')} </span> </td>
          <td>{collateralizedNrg} OVERLINE</td>
          <td style={{lineHeight:'25px',fontSize:'10px',width:'160px',paddingTop:'10px',paddingBottom:'10px'}}>{you}</td>
        </tr>
      );
    });
    return items;
  }
  renderUnmatched(orders) {
    return (
      <div>
        <table className="white-text order-book striped" style={{tableLayout:"fixed",fontSize:"0.9em",height:'30px',lineHeight:'30px'}}>
          <tbody>
            {this.renderItemUnlock(orders)}
          </tbody>
        </table>
        {this.renderUnlock()}
      </div>
    )
  }
  render() {
    let items = ['Send','Receive','Collateral','Status']
    let text = `Unmatched Orders (${this.props.orders.length})`
    let {orders} = this.state;

    let noOrders = this.props.orders.length == 0;
    return (
      <div className='col m6' style={{paddingRight:'0.375rem',marginTop:'5px'}}>
        <div className='col s12'>
          <h6 style={{marginTop:'10px',float:'left'}}>
            <span style={{cursor:'pointer',paddingRight:'10px',color:'white'}}> {text} </span>
          </h6>

          {this.props.orders.length > 0 &&
            <h6 style={{marginTop:'10px',float:'right'}} onClick={this.handleAllUnlock.bind(this)}>
              <span className='hoverC' style={{cursor:'pointer',paddingRight:'10px',color:'grey'}}>
              Unlock All
              </span>
            </h6>
          }

        </div>

        <div className='col s12 section'>
          <TableHeader items={items} width={`160px`}/>
          <div className="col s12 myOrders">
            <InfiniteScroll
             className="infiniteScrollComponent"
                  height={200}
                  dataLength={orders.length}
                  next={this.fetchMoreData.bind(this)}
                  hasMore={this.state.hasMore}
              >
            {this.renderUnmatched(orders)}
            {noOrders ?
              <p style={{color:'grey',marginLeft:'5px',marginTop:0,fontSize:'10px'}}> No Orders</p>
              : null
            }
            </InfiniteScroll>
          </div>
        </div>
      </div>
    )
  }
}

function mapStateToProps(state,props) {
  return {
    orders: state.orderbook.my_unmatched_orders
  };
}

export default connect(mapStateToProps, {unlockCollateral})(Orders);
